import { useTranslation } from 'react-i18next';
import { isBefore } from 'src/utils/time';
import styled from 'styled-components';
import * as Types from '../../types';
import MessageListBox from '../messages/MessageListBox';
import { PublicLoggedInContainerWithNavbar } from '../organismsLegacy/LoggedInContainer/PublicLoggedInContainerWithNavbar';

const PublicMessageContainer = styled.div`
  width: 100%;
  background: rgba(255, 255, 255, 0.7);
  height: 100%;
  background-size: 40%;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media screen and (min-width: 0px) and (max-width: 480px) {
    background-size: 80%;
  }
`;

interface Props {
  organisation: string;
  currentUser: Types.User;
  publicReports: Types.Report[];
  messages: Map<string, Types.Message[]>;
  unreadMessages: boolean;
}

const PublicMessageList = (props: Props) => {
  const { t } = useTranslation();
  const messageList = [];
  for (let [key, message] of props.messages.entries()) {
    const unreadMessages = message.filter(
      (m: Types.Message) =>
        m.state !== Types.MessageState.READ && !m.isReporter,
    ).length;
    const report = props.publicReports.find((r) => r.reportId === key);

    messageList.push(
      <MessageListBox
        key={key}
        organisation={props.organisation}
        unreadCount={unreadMessages}
        lastMessage={
          message.sort((a, b) =>
            isBefore(b.createdAt, a.createdAt) ? -1 : 1,
          )[0]
        }
        reportId={key}
        reportedCategory={report?.reportedCategory?.name || report?.type || ''}
      />,
    );
  }

  return (
    <PublicLoggedInContainerWithNavbar
      organisation={props.organisation}
      currentUser={props.currentUser}
      selectedTabIndex={1}
      hideMenusWhenSmall={false}
      greyBackground
      subHeader={t('public.PublicMessageList.myMessages')}
      hideID={props.publicReports.every(
        (report) => report.source === 'vault-talk',
      )}
    >
      <PublicMessageContainer>{messageList}</PublicMessageContainer>
    </PublicLoggedInContainerWithNavbar>
  );
};

export default PublicMessageList;
